import { api } from "./client.js";
import type { DashboardData } from "@wwrp/shared";

export const dashboardApi = {
  get: () => api.get<DashboardData>("/dashboard"),
};
